import React, { useEffect, useState, version } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  TextField,
  Button,
  Chip,
  Divider,
  Stack,
  FormControl,
  Select,
  MenuItem
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import ArticleIcon from "@mui/icons-material/Article";
import { getCompanyName } from "../utils/utility";
import ChangeLogPopup  from './ChangesLog';
import Loader from "./Loader";

const allowedScopeForDev = 'hd-test'

const VersionHistoryCard = ({ versions, openDialog, componentScope, userData, showLoader, commentMessage, componentName }) => {
  const [comment, setComment] = useState('');
  const [statusFilter, setStatusFilter] = useState("all");

  const [openChangelog, setOpenChangelog] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState("");
  const [selectedPublishDate, setSelectedPublishDate] = useState("");

  const handleOpenChangelog = (version, date) => {
    setSelectedVersion(version);
    setSelectedPublishDate(date);
    setOpenChangelog(true);
  };


  const userCompany = getCompanyName(userData?.user?.email);
  useEffect(() => {
    setComment(commentMessage)

  }, [commentMessage])

  const uniqueStatuses = ["all", ...new Set((versions || []).map(v => v.status).filter(Boolean))];
  const filteredVersions = versions ? versions.filter(v => statusFilter === "all" || v.status === statusFilter) : versions;


  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
          <Typography variant="h6" sx={{ mb: 0 }}>
            Version History
          </Typography>
          <FormControl size="small" sx={{ minWidth: 200 }}>
            <Select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              displayEmpty
            >
              <MenuItem value="all">All Statuses</MenuItem>
              {uniqueStatuses.filter(s => s !== "all").map(status => (
                <MenuItem key={status} value={status}>
                  {status}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Stack spacing={6}>
          {filteredVersions && filteredVersions.length ? filteredVersions.map((v, idx) => (
            <Box
              key={idx}
              sx={{
                borderLeft: `4px solid ${v.borderColor}`,
                pl: 2
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center"
                }}
              >
                <Box>
                  <Typography variant="subtitle1" fontWeight="bold">
                    v{v.version}{" "}
                    <Typography
                      component="span"
                      variant="body2"
                      color="text.secondary"
                    >
                      {v.date}
                    </Typography>
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {v.submittedBy ? <>Submitted by <strong>{v.submittedBy}</strong></> : ''}

                  </Typography>
                </Box>
                <Box sx={{display:'flex'}}>
                  <Chip
                    label={v.status}
                    color={v.statusColor}
                    variant="outlined"
                    sx={{
                      bgcolor: `${v.statusColor}.100`,
                      color: `${v.statusColor}.800`
                    }}
                  />
                  <Box
                    ml={2}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 0.5,
                      cursor: "pointer",
                      color: "primary.main",
                      "&:hover": { textDecoration: "underline" }
                    }}
                  onClick={() => handleOpenChangelog(v.version, v.date)}
                  >
                    <ArticleIcon sx={{ fontSize: 20 }} />   {/* icon */}
                    <Typography variant="caption">
                      View Changelog
                    </Typography>
                  </Box>
                </Box>

              </Box>


              <Typography variant="body2" sx={{ mt: 2 }}>
                {v.comment ? <><strong>Comment:</strong> {v.comment} </> : ''}
              </Typography>

              {v.showActions && (
                <>
                  <Divider sx={{ mt: 4, mb: 2 }} />
                  <Typography variant="subtitle1" gutterBottom>
                    Add a Comment
                  </Typography>
                  <Box sx={{ display: "flex", gap: 2 }}>
                    <Avatar
                      src="https://lh3.googleusercontent.com/aida-public/AB6AXuCvlH63Jc6VnNQ_pHau_7HxQvkrEMbntL5oI8v1kvggbBPVBm0Kk1X5cadR9RPgXvpuktPfWGNPy34X0v_WyO5YM7y8UIKOpYeCf0-B_fyaHKdZwq12TlAT4Urs4wrcgjS9llzrVDB_kG-TfYhalnXRJ00cLgdJclVpo_W5Lyr0fF1vdfU1wWzbh0JPFtuWpTpgFk2VXX9fJmdVSgkEdR72QTfgtusD2cjUJDEDdhFWMKksknKCUbZc6uY4Z--1whAICDQU9jihm4c"
                      alt="User"
                      sx={{ width: 40, height: 40 }}
                    />
                    <Box sx={{ flex: 1 }}>
                      <TextField
                        fullWidth
                        multiline
                        minRows={3}
                        placeholder="Post a comment on this version..."
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          mt: 2
                        }}
                      >
                        <Stack direction="row" spacing={2}>
                          {v.status && process.env.REACT_APP_STAGE === 'development' && (
                            showLoader ? (
                              <Box sx={{ marginLeft: 'auto' }}>
                                <Loader />
                              </Box>
                            ) : v.status === 'submitted' && userCompany === 'hyperdart' ? (
                              <>
                                <Button
                                  variant="contained"
                                  color="success"
                                  sx={{ marginLeft: 'auto', textTransform: 'none', marginRight: '10px' }}
                                  onClick={() => openDialog('moveToDev', comment, v?.version)}
                                >
                                  Move {componentName}@{v?.version} To Dev
                                  <CheckCircleIcon sx={{ ml: 1 }} />
                                </Button>

                                <Button
                                  variant="contained"
                                  color="error"
                                  sx={{ textTransform: 'none' }}
                                  onClick={() => openDialog('rejectDev', comment, v?.version)}
                                >
                                  Reject
                                  <CancelIcon sx={{ ml: 1 }} />
                                </Button>

                              </>

                              ) : v.status === 'underReview'  && componentScope !== allowedScopeForDev  ? <>
                                  <Button
                                    variant="contained"
                                    color="info"
                                    sx={{ marginLeft: 'auto', textTransform: 'none', marginRight: '10px' }}
                                    onClick={() => openDialog('markTested', comment, v?.version)}
                                  >
                                    Mark {componentName}@{v?.version} as Tested
                                    <CheckCircleIcon sx={{ ml: 1 }} />
                                  </Button> 

                                  <Button
                                    variant="contained"
                                    color="error"
                                    sx={{ textTransform: 'none' }}
                                    onClick={() => openDialog('rejectProd', comment, v?.version)}
                                  >
                                    Reject
                                    <CancelIcon sx={{ ml: 1 }} />
                                  </Button>
                                
                            </>

                              :
                              v?.status === 'tested' || v?.status === 'resourceToStaging' && userData?.is_staff && componentScope !== allowedScopeForDev ? (
                                <>
                                      {
                                        v.status !== 'resourceToStaging' && <Button
                                          variant="contained"
                                          color="inherit"
                                          sx={{ marginLeft: 'auto', textTransform: 'none', marginRight: '10px' }}
                                          onClick={() => openDialog('moveResourceToStaging', comment, v?.version)}
                                        >
                                          Move Resource to Staging
                                        </Button>
                                      }
                                  <Button
                                    variant="contained"
                                    color="success"
                                    sx={{ marginLeft: 'auto', textTransform: 'none', marginRight: '10px' }}
                                    onClick={() => openDialog('moveToProd', comment, v?.version)}
                                  >
                                    Move {componentName}@{v?.version} To Prod
                                    <CheckCircleIcon sx={{ ml: 1 }} />
                                  </Button>

                                </>
                              ) : null
                          )}
                        </Stack>


                      </Box>
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          )) : versions && !versions.length ?  (
            <Typography variant="body2" color="text.secondary">
              No versions found
            </Typography>
          ) : filteredVersions && !filteredVersions.length ? (
            <Typography variant="body2" color="text.secondary">
              No versions found for the selected status
            </Typography>
          ) : <Loader />}
        </Stack>
      </CardContent>

      <ChangeLogPopup
        open={openChangelog}
        handleClose={() => setOpenChangelog(false)}
        version={selectedVersion}
        publishDate={selectedPublishDate}
        componentName={componentName}
      />

    </Card>
  );
};

export default VersionHistoryCard;
